// src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './theme.css';

import App from './App';
import ConfirmPage from './ConfirmPage';
import ConfirmByPinPage from './ConfirmByPinPage';
import PrivacyPage from './PrivacyPage';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { isNative, initNativePushHandlers } from './nativePush';

// Ulkoasu: "kentta" (oletus) tai "classic". Asetetaan ennen renderöintiä,
// ettei ensimmäinen ruutu välähdä väärillä väreillä.
try {
  const skin = localStorage.getItem("spinloop_skin");
  if (skin === "classic") document.documentElement.dataset.skin = "classic";
  if (localStorage.getItem("spinloop_dark") === "1") document.documentElement.dataset.theme = "dark";
} catch { /* localStorage voi puuttua */ }

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/confirm/:token" element={<ConfirmPage />} />
        <Route path="/confirm-pin" element={<ConfirmByPinPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
//
// MUUTOS: Vaihdettu .register() -> .unregister(), jotta käytetään vain
// public/firebase-messaging-sw.js -tiedostoa.
//
// Aiemmin tässä luki että se tiedosto hoitaa myös cachingin. Se ei pidä
// paikkaansa: siinä ei ole fetch-käsittelijää lainkaan, vain push. Mitään
// ei siis välimuistiteta service workerissa, eikä PWA toimi offline.
// Päivitysten havaitseminen hoituu src/useAppUpdate.ts:ssä kysymällä
// palvelimelta, koska auki oleva PWA-ikkuna ei hae index.html:ää uudelleen.
serviceWorkerRegistration.unregister();

// Natiivikuoressa ilmoitukset tulevat kayttojarjestelmalta, ei service workerilta.
// Kytketaan ilmoituksen napsautus sovelluksen navigaatioon.
if (isNative()) {
  // WKWebView sallii nipistyszoomin, ja zoom jaa paalle: nakyma jumittuu
  // vaaraan kohtaan eika kayttaja loyda takaisin. Natiiviappi ei saa
  // kayttaytya niin. Verkossa zoom sailyy, koska sen poistaminen sielta
  // olisi saavutettavuusongelma.
  document
    .querySelector('meta[name="viewport"]')
    ?.setAttribute(
      "content",
      "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover"
    );

  initNativePushHandlers();

  // Kaynnistysruutu piiloon vasta kun sisalto on piirretty
  window.addEventListener("load", () => {
    import("@capacitor/splash-screen").then(({ SplashScreen }) =>
      SplashScreen.hide({ fadeOutDuration: 300 })
    );
  });
}

// Jos haluat myöhemmin käyttää CRA:n omaa service workeria PWA-päivitysten hallintaan
// yhdessä FCM-service workerin kanssa, se vaatii monimutkaisempaa integraatiota.
// Tällä hetkellä yksinkertaisin tapa on käyttää vain yhtä service workeria.
/*
serviceWorkerRegistration.register({
  onUpdate: (registration: ServiceWorkerRegistration) => {
    const waitingServiceWorker = registration.waiting;

    if (waitingServiceWorker) {
      if (window.confirm("Sovelluksesta on uusi versio saatavilla. Haluatko ladata sen nyt? Selain päivittyy automaattisesti.")) {
        waitingServiceWorker.addEventListener("statechange", event => {
          const sw = event.target as ServiceWorker; 
          if (sw && sw.state === "activated") {
            window.location.reload();
          }
        });
        waitingServiceWorker.postMessage({ type: "SKIP_WAITING" });
      } else {
        console.log("Käyttäjä kieltäytyi Service Worker -päivityksestä.");
      }
    } else {
      console.log("Ei odottavaa Service Workeria päivitystä varten tai registration.waiting on null.");
    }
  },
  onSuccess: (registration: ServiceWorkerRegistration) => {
    console.log("Service Worker rekisteröity onnistuneesti (CRA default):", registration);
  }
});
*/

reportWebVitals();
